import { render, staticRenderFns } from "./SupplierPackaging.vue?vue&type=template&id=6c24e526&scoped=true&"
import script from "./SupplierPackaging.vue?vue&type=script&lang=js&"
export * from "./SupplierPackaging.vue?vue&type=script&lang=js&"
import style0 from "./SupplierPackaging.vue?vue&type=style&index=0&id=6c24e526&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c24e526",
  null
  
)

export default component.exports